export enum Context {
  DIAGNOSIS = 'diagnosis',
  SCANNER = 'scanner',
  REPORT = 'report',
  APPOINTMENT = 'appointment',
  COLLECT = 'collect',
  UNKNOWN = 'unknown'
}
